interface Props {
	msg: string;
}

export function EmptyMessage({ msg }: Props) {
	return (
		<div
			className="empty-state"
			style={{
				padding: "40px",
				textAlign: "center",
				color: "#9ca3af",
				fontSize: "13px",
			}}
		>
			{msg}
		</div>
	);
}
